import MuiGrid from '@mui/material/Grid';
import type { GridProps } from './IGrid';
import { styles } from './styles';

const Grid = ({ sx, ...rest }: GridProps) => (
    <MuiGrid
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Grid;
